import {LANDOWNERS} from "../../constants/landowners";

export function fetchLandowners(params) {
    return {
        type: LANDOWNERS.FETCH_LANDOWNERS.MAIN,
        params
    }
}
